import * as React from "react";

interface AccessibleIconProps {
	children?: React.ReactNode;
	/**
	 * The accessible label for the icon. This label will be visually hidden but announced to screen
	 * reader users, similar to `alt` text for `img` tags.
	 */
	label?: string;
}

// Inspired by @radix-ui/react-accessible-icon
export const AccessibleIcon = ({ children, label }: React.PropsWithChildren<AccessibleIconProps>) => {
	const child = React.Children.only(children);

	return (
		<>
			{React.cloneElement(child as React.ReactElement<React.SVGAttributes<SVGElement>>, {
				"aria-hidden": true,
				focusable: "false", // See: https://allyjs.io/tutorials/focusing-in-svg.html#making-svg-elements-focusable
			})}
			{label && <span className="sr-only">{label}</span>}
		</>
	);
};
